<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NotesWarningModal',

  props: {
    visible: { type: Boolean, required: true },
    notes: { type: String, default: '' }
  }
})
</script>

<template>
  <gtr-modal title="Participant Notes" :value="visible" :width="500" :closable="true" @close="$emit('cancel')">
    <p class="mb-3">This participant has notes on their record. Please review before printing:</p>
    <v-card outlined class="pa-3 mb-5" style="white-space: pre-wrap; max-height: 200px; overflow-y: auto;">{{ notes }}</v-card>
    <v-row align="center" justify="end" no-gutters>
      <v-col cols="auto">
        <v-btn class="priority-default mr-3" @click="$emit('cancel')">Cancel</v-btn>
        <v-btn class="priority-focus" @click="$emit('confirm')">Print Anyway</v-btn>
      </v-col>
    </v-row>
  </gtr-modal>
</template>
